<app-header></app-header>
<section class="skills my-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="FAQs-content-child">
                <h2>Data Deletion Policy</h2>
                <br />
                <p>
                    Under the General Data Protection Regulation (GDPR), you have the right to have your data deleted and removed from our systems. You may email us to request that your data be
                    deleted. Please be aware that, despite your request to have your data deleted, there are specific reasons for which we may decline your request and your data will continue to be
                    processed. These reasons are set out below.
                </p>

                <p>You have the right to have your data deleted in the following circumstances:</p>

                <ul>
                    <li>Where the personal data is no longer necessary in relation to the purpose for which ParkUpp originally collected or processed it.</li>
                    <li>Where you have withdrawn your consent to the continued processing of the data and there is no other lawful basis for ParkUpp to continue processing the data.</li>
                    <li>Where you object to the processing. In this case, ParkUpp will make a determination over where it has an overriding legitimate interest to continue the processing.</li>
                    <li>The personal data has been unlawfully processed.</li>
                    <li>The personal data has to be deleted due to a legal obligation.</li>
                </ul>

                <p>You must insert the appropriate reason for your request in your email.</p>

                <p>Upon receipt of a request, ParkUpp will delete the data unless it is processed for one of the following reasons:</p>

                <ul>
                    <li>To exercise the rights of freedom of expression and information.</li>
                    <li>For ParkUpp to comply with a legal requirement.</li>
                    <li>The performance of a task carried out in the public interest or exercise of official authority.</li>
                    <li>For public health purposes in the public interest.</li>
                    <li>Archiving purposes in the public interest, scientific historical research or statistical purposes.</li>
                    <li>The defence of legal claims.</li>
                </ul>

                <p>If one of the circumstances above applies, your request for deletion will be refused. The Company will write to you setting out the reason for refusal.</p>

                <a class="btn btn-danger text-white" href="mailto:info@parkupp.co.za" target="_blank">Send data deletion request</a>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
